import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["context", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import { isFunction } from '@jd/jmtd-tools/es/is';
import ConfigProvider from '../ConfigProvider';
import ConfigConsumer from '../ConfigConsumer';
export default function ConfigConsumerProvider(_ref) {
  var context = _ref.context,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ConfigConsumer, _extends({
    context: context
  }, props), function (configValue) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return /*#__PURE__*/React.createElement(ConfigProvider, _extends({
      context: context
    }, configValue), isFunction(children) ? children.apply(void 0, [configValue].concat(args)) : children);
  });
}
ConfigConsumerProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  context: PropTypes.object
};
ConfigConsumerProvider.defaultProps = {
  children: null,
  context: undefined
};